import { MachineFaultDto } from '@shared/models';
import { SimpleComparator } from '@shared/helpers';
import { SORT_COLUMN } from '../organizations/organizations.comparator';
import { SortDirection } from '@gea/digital-ui-lib';

export class FaultComparator {
  static by(columnName: SORT_COLUMN, sortingOrder: SortDirection) {
    if (columnName === SORT_COLUMN.TOTAL_PENDING) {
      return SimpleComparator.by<MachineFaultDto>(SORT_COLUMN.TOTAL_PENDING, sortingOrder);
    } else {
      return SimpleComparator.by<MachineFaultDto>(columnName, sortingOrder);
    }
  }
}
